import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import { NavLink } from "react-router-dom";
import { WriterInfo } from "../WriterInfo/WriterInfo";

export const CardCollectionBook = ({
  collection,
  date,
  rd = 8,
  borderType = "full",
  isRemarkable = false,
  isRanked = false,
  rank = 0,
  isMobile,
  isMe = false,
  size = "default", // "default" | "large"
}) => {
  const theme = useTheme();

  // 사이즈별 설정 (모바일에서는 size 무시)
  const isLarge = !isMobile && size === "large";
  const cardHeight = isMobile ? "240px" : 440; // 모바일에서 고정 높이
  const titleVariant = isMobile ? "h6" : (isLarge ? "h4" : "h5");
  const descriptionVariant = isMobile ? "body1" : "h6";
  const writerInfoSize = isMobile ? "small" : (isLarge ? "xl" : "large");
  const titleHeight = isMobile ? 68 : isLarge ? 72 : 72;
  const descriptionHeight = isMobile ? "48px" : "58px"; // 모바일에서 2줄 고정

  return (
    <NavLink
      to={
        isMe
          ? `/my-collection/${collection.id}`
          : `/collection/${collection.id}`
      }
      style={{ width: "100%" }}
    >
      <CardContainerRetro
        w={"100%"}
        rd={rd}
        bg={theme.palette.background.paper}
        borderType={borderType}
      >
        <Stack
          spacing={isMobile ? 2 : 12}
          justifyContent="space-between"
          sx={{
            padding: isMobile ? theme.spacing(2) : theme.spacing(3),
            width: "100%",
            height: cardHeight,
            minHeight: isMobile ? "auto" : cardHeight, // 모바일에서 최소 높이 제거
            borderRadius: theme.spacing(0.5),
          }}
        >
          <Stack spacing={0.5}>
            <Typography
              variant={titleVariant}
              sx={{
                fontFamily: '"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif',
                lineHeight: isMobile ? 1.55 : isLarge ? 1.7 : 1.55,
                height: titleHeight,
                fontWeight: 900,
                width: "100%",
                color: theme.palette.text.primary,
                overflow: "hidden",
                wordBreak: "break-word",
                textOverflow: "ellipsis",
              }}
            >
              {collection.title}
            </Typography>
            <Typography
              variant={descriptionVariant}
              sx={{
                height: descriptionHeight,
                // color: theme.customTokens.colors.custom.ui.dark.bold,
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {collection.description}
            </Typography>
          </Stack>
          <WriterInfo
            size={writerInfoSize}
            profileImage={collection.profileImage}  // 기존 필드 유지
            userID={collection.userID}              // 🆕 신규 필드 추가
            username={collection.username}
            name={collection.name}
            sx={{
              marginLeft: isMobile ? '-8px' : 0,
            }}
          />
        </Stack>
      </CardContainerRetro>
    </NavLink>
  );
};
